<style scoped lang="less">
.underline {
    border-bottom: 1px solid;
    padding-bottom: 2px;
}
.bold {
    font-weight: normal;
}
.indent {
    text-indent: 32px;
}
.pre {
    background: white;
    color: black;
    width: 700px;
    height: 1131px;
    margin: 0 auto;
    position: relative;
}
.header {
    width: 100%;
    margin-bottom: 10px;
    .title {
        margin-top: 20px;
        text-align: center;
        font-size: 24px;
        cursor: pointer;
    }
    .detail {
        margin-top: 20px;
        font-size: 18px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }
}
.container {
    line-height: 35px;
    margin-top: 30px;
    width: 100%;
    font-size: 16px;
}
.shenheyijian {
    margin-top: 70px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
</style>

<template>
    <div class="yb-container">
        <div class="pre">
            <div class="header">
                <div class="title bold" @click.stop="printOut">货&nbsp;&nbsp;权&nbsp;&nbsp;转&nbsp;&nbsp;让&nbsp;&nbsp;书</div>
                <div class="detail">
                    <div>编号：<span class="underline">&nbsp;&nbsp;&nbsp;{{forward.orderNO}}&nbsp;&nbsp;&nbsp;</span></div>
                </div>
            </div>

            <div class="container">
                <div class="bold">{{forward.house}}：</div>
                <div class="indent">鉴于我单位自行签订/从
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{forward.purchaser0}}&nbsp;&nbsp;&nbsp;</span>）转至我单位的
                    <span class="underline">&nbsp;&nbsp;&nbsp;进口甲醇&nbsp;&nbsp;&nbsp;</span>（品项）
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{forward.count}}&nbsp;&nbsp;&nbsp;</span>吨货物的仓储保管合同（合同编号：），现我单位将该货物全部/其中
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{forward.count}}&nbsp;&nbsp;&nbsp;</span>吨的货权转让给
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{forward.purchaser2}}&nbsp;&nbsp;&nbsp;</span>，请贵司依此放货给
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{forward.purchaser2}}&nbsp;&nbsp;&nbsp;</span>。自
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{myYear}}&nbsp;&nbsp;&nbsp;</span>年
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{myMonth}}&nbsp;&nbsp;&nbsp;</span>月
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{myDate}}&nbsp;&nbsp;&nbsp;</span>日起的仓储费由
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{forward.purchaser2}}&nbsp;&nbsp;&nbsp;</span>承担。
                </div>
                <div class="indent">同时，我单位承诺此货权转让书不可撤销，贵司系按我单位指示放货，由此产生一切责任及损害后果由我单位承担。</div>

                <div class="shenheyijian">
                    <div>{{forward.purchaser1}}</div>
                    <div>{{forward.date}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HttpClient } from "../util/http";
import { actionConfirm, msgSuccess } from "../util/toast";
import dayjs from "dayjs";

export default {
    data() {
        return {
            forward: null
        };
    },
    computed: {
        myYear() {
            return dayjs(this.$route.query.downDate).format("YYYY");
        },
        myMonth() {
            return dayjs(this.$route.query.downDate).format("M");
        },
        myDate() {
            return dayjs(this.$route.query.downDate).format("D");
        }
    },
    components: {},
    created() {
        this.forward = {
            orderNO: this.$route.query.orderNO,
            house: this.$route.query.house,
            purchaser0: this.$route.query.purchaser0,
            purchaser1: this.$route.query.purchaser1,
            purchaser2: this.$route.query.purchaser2,
            count: this.$route.query.count,
            date: dayjs(this.$route.query.date).format("YYYY年MM月DD日"),
            downDate: dayjs(this.$route.query.downDate).format("YYYY年MM月DD日")
        };
    },
    methods: {
        printOut() {
            window.print();
        }
    }
};
</script>


        